import styled, { css } from 'styled-components';

const Button = styled.button`
  width: 100%;
  padding: 1rem 0.5rem;

  color: ${({ theme }) => theme.colors.white};
  font-weight: 400;
  font-size: 1.325rem;
  font-family: 'Source Sans Pro', sans-serif;
  text-transform: uppercase;
  text-decoration: none;

  background-color: ${({ theme }) => theme.colors.robinsEggBlue};

  border: none;
  border-radius: 0.25rem;
  cursor: pointer;

  user-select: none;

  &:focus {
    outline: none;
  }

  ${({ disabled, theme }) =>
    disabled &&
    css`
      background-color: ${theme.colors.iron};
      pointer-events: none;
    `};

  ${({ theme }) => theme.devices.tablet`
    font-size: 1.5rem;
  `}
`;

export default Button;
